import { endpoint } from './apiConstants';
import axios from '@/plugins/axios';

export const getAdvertisement = async () => {
    const res = await axios.get(endpoint.getAdvertisement);
    return res;
};

export const updateAdvertisementBrowsingFlag = async (tGadContractId: number, dispCnt: number) => {
    const param = {
        tGadContractId: tGadContractId,
        dispCnt: dispCnt
    };
    const res = await axios.post(endpoint.updateAdvertisementBrowsingFlag, param);
    return res;
};